import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.scss'
import { getStaticUrl, getSpriteUrl } from './mixins/staticFiles.js'
import analyticsTracking from './mixins/analyticsTracking.js'

const app = createApp(App)

// Добавляем глобальные методы для работы со статическими файлами
app.config.globalProperties.$getStaticUrl = getStaticUrl
app.config.globalProperties.$getSpriteUrl = getSpriteUrl

// Добавляем глобальный миксин для аналитики
app.mixin(analyticsTracking)

app.use(router)
app.mount('#app') 